import { render, staticRenderFns } from "./cItem.vue?vue&type=template&id=05f04098&"
import script from "./cItem.vue?vue&type=script&lang=js&"
export * from "./cItem.vue?vue&type=script&lang=js&"
import style0 from "./cItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports